import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.cdp.cof";
export interface OperaSignals {
    contentViewSource: number;
    playbackItemType: number;
    useVerticalNavigation: boolean;
}
function createBaseOperaSignals(): OperaSignals {
    return { contentViewSource: 0, playbackItemType: 0, useVerticalNavigation: false };
}
export const OperaSignals: MessageFns<OperaSignals> = {
    encode(message: OperaSignals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.contentViewSource !== 0) {
            writer.uint32(8).int32(message.contentViewSource);
        }
        if (message.playbackItemType !== 0) {
            writer.uint32(16).int32(message.playbackItemType);
        }
        if (message.useVerticalNavigation !== false) {
            writer.uint32(24).bool(message.useVerticalNavigation);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): OperaSignals {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOperaSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.contentViewSource = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.playbackItemType = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.useVerticalNavigation = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<OperaSignals>, I>>(base?: I): OperaSignals {
        return OperaSignals.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<OperaSignals>, I>>(object: I): OperaSignals {
        const message = createBaseOperaSignals();
        message.contentViewSource = object.contentViewSource ?? 0;
        message.playbackItemType = object.playbackItemType ?? 0;
        message.useVerticalNavigation = object.useVerticalNavigation ?? false;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
